<template>
    <div id="loginPage" v-loading="loading">
        <div class="backToHome" @click="$router.replace('/')">
            返回首页
        </div>
        <div class="left">
            <div class="logo">
                <img :src="logo" alt=""/>
            </div>
            <div class="text">
                <div class="row">
                    FEITEM
                </div>
                <div class="row">
                    微观表征数智化平台
                </div>
            </div>
        </div>
        <div class="right">
            <div class="box">
                <div class="title">
                    <h1 v-if="type == 1">欢迎登录</h1>
                    <h1 v-if="type == 2">欢迎注册</h1>
                </div>
                <div class="input" v-if="type == 1" @keyup.enter="$root.login(form.account,form.password)">
                    <el-input placeholder="请输入邮箱/手机号" v-model="form.account" clearable>
                        <template slot="prepend"><i class="el-icon-user icon"></i></template>
                    </el-input>
                    <el-input placeholder="请输入密码" v-model="form.password" show-password>
                        <template slot="prepend"><i class="el-icon-lock icon"></i></template>
                    </el-input>
                    <div class="forget" @click="showForget = true">
                        忘记密码
                    </div>
                    <div class="buttonGroup">
                        <el-button type="primary" @click="login()">登录</el-button>
                        <el-button @click="type = 2">注册</el-button>
                    </div>
                </div>

                <div class="input" v-if="type == 2" @keyup.enter="register" v-loading="getCaptchaLoading">
                    <div class="row">
                        <div class="title required">姓名</div><el-input ref="name" placeholder="请输入姓名" v-model="regForm.name" clearable></el-input>
                    </div>
                    <div class="row">
                        <div class="title">单位</div>
                        <el-select v-model="regForm.lab_id" placeholder="请选择单位">
                            <el-option
                            v-for="(item, key) in labOptions"
                            :key="key"
                            :label="item"
                            :value="Number(key)">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="row" v-if="regForm.lab_id === 0">
                        <div class="title">填写单位</div><el-input ref="company" placeholder="请输入工作单位" v-model="regForm.company" clearable></el-input>
                    </div>

                    <div class="row" v-if="regForm.lab_id && regForm.lab_id != 0">
                        <div class="title required">学号</div>
                        <el-input ref="student_id" placeholder="请输入学号" v-model="regForm.student_id" clearable></el-input>
                    </div>

                    <div class="row">
                        <div class="title required">Email</div>
                        <el-input ref="email" placeholder="请输入邮箱" v-model="regForm.email" clearable></el-input>
                    </div>    
 
                    <div class="row">
                        <div class="title required">手机号</div>
                        <el-input placeholder="请输入手机号" v-model="regForm.mobile" clearable>
                            <template slot="append">
                                <div ref="getCaptcha" :class="getCaptchaClass" @click="getCaptcha(false,'register')">
                                    {{ getCaptchaText }}
                                </div>
                            </template>
                        </el-input>
                    </div>        
                    <div class="row">
                        <div class="title required">验证码</div>
                        <el-input ref="code" placeholder="请输入验证码" v-model="regForm.code" clearable></el-input>
                    </div> 
                    <div class="row">
                        <div class="title required">密码</div><el-input ref="password" placeholder="请输入密码" v-model="regForm.password" show-password></el-input>
                    </div>
                    <div class="row">
                        <div class="title required">重复密码</div><el-input ref="repassword" placeholder="请再次输入密码" v-model="regForm.repassword" show-password></el-input>
                    </div>
                    <!-- <div class="row">
                        <div class="title">职业</div>
                        <el-select v-model="regForm.career_id" placeholder="请选择">
                            <el-option
                            v-for="item in jobOptions"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div> -->
                    <div class="regButtonGroup">
                        <el-button type="primary" @click="register">注册</el-button>
                        <el-button @click="type = 1">返回</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <span class="info"><img :src="Mail"/>邮箱:sales@feitem.com.cn</span>
            <span class="info"><img :src="Address"/>地址:河南自贸试验区开封片区郑开大道八大街以西三合国际4楼</span>
            <span class="copyright">COPYRIGHT © 2024 河南元宇宙仪器有限公司 ALL RIGHTS RESERVED 豫ICP备2023009490号-1</span>
            <img :src="service"/>
        </div>

        <el-dialog class="dialog" title="找回密码" :visible.sync="showForget" width="30%">
            <div v-loading="getCaptchaLoading">
                <div class="forgetBox">
                    <div class="row">
                        <div class="title">手机号</div>
                        <el-input placeholder="请输入手机号" v-model="forgetForm.mobile" clearable></el-input>
                    </div>          
                    <div class="row">
                        <div class="title">验证码</div>
                        <el-input class="captchaInput" placeholder="请输入验证码" v-model="forgetForm.captcha" clearable></el-input>
                        <div ref="getCaptcha" :class="getCaptchaClass" @click="getCaptcha(false,'resetpwd')">
                            {{ getCaptchaText }}
                        </div>
                    </div>    
                    <div class="row">
                        <div class="title">新密码</div>
                        <el-input placeholder="请输入新密码" show-password v-model="forgetForm.newpassword" clearable></el-input>
                    </div>    
                    <div class="row">
                        <div class="title">重复密码</div>
                        <el-input placeholder="请再次输入新密码" show-password v-model="forgetForm.renewpassword" clearable></el-input>
                    </div>          
                </div>
                <div class="buttonGroup">
                    <el-button type="primary" @click="submitResetpwd">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import logo from '@/assets/img/logo2.png';
import service from '@/assets/img/service.png';
import Mail from '@/assets/img/mail.png';
import Address from '@/assets/img/address.png';
import axios from 'axios';

export default {
  name: 'loginPage',
    data() {
        return{
            logo:logo,
            service:service,
            Mail:Mail,
            Address:Address,
            type:1,
            showForget:false,
            loading:false,
            lastGetCaptchaTime:0,
            getCaptchaText:"获取验证码",
            getCaptchaClass:"getCaptcha",
            getCaptchaLoading:false,
            form:{
                account:"",
                password:""
            },
            regForm:{
                email:"",
                mobile:"",
                password:"",
                repassword:"",
                name:"",
                career_id:"",
                company:"",
                code:"",
                lab_id:0,
                student_id:"",
                settled_unit_branch_id:"",
            },
            forgetForm:{
                mobile:"",
                captcha:"",
                newpassword:"",
                renewpassword:"",
            },
            jobOptions:[],
            labOptions:{},
        }
    },
    watch:{
    },
    methods:{
        test(){
            console.log(this.$router)
        },
        async login(){
            this.loading = true;
            await this.$root.login(this.form.account,this.form.password)
            this.loading = false;
        },
        async getjobOptions(){
            this.loading = true;
            let isLogin = await this.$root.checkLogin();
            if(isLogin){
                this.$router.replace({
                    name:'userCenter'
                });
                return
            }
            let data = await this.$root.getJobList();            
            this.jobOptions = data.data;
            this.loading = false;
        },
        async register(){
            this.loading = true;
            //数据验证
            let regForm = this.regForm;
            if(regForm.email == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入邮箱'
                });
                this.loading = false;
                this.$refs.email.focus();
                return;
            }
            if(regForm.password == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入密码'
                });
                this.loading = false;
                this.$refs.password.focus();
                return;
            }
            if(regForm.repassword == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入重复密码'
                });
                this.loading = false;
                this.$refs.repassword.focus();
                return;
            }
            if(regForm.password != regForm.repassword){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '两次密码不一致'
                });
                this.loading = false;
                return;
            }
            if(regForm.name == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入姓名'
                });
                this.loading = false;
                this.$refs.name.focus();
                return;
            }
            if(regForm.code == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入验证码'
                });
                this.loading = false;
                this.$refs.code.focus();
                return;
            }
            if(regForm.lab_id && regForm.lab_id != 0 && regForm.student_id == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入学号'
                });
                this.loading = false;
                this.$refs.student_id.focus();
                return;
            }
            // if(regForm.company == ""){
            //     this.$message.error("请输入单位");
            //     this.loading = false;
            //     this.$refs.company.focus();
            //     return;
            // }
            // 设置 settled_unit_branch_id 为选中的机构 id（后端字段变更）
            regForm.settled_unit_branch_id = String(regForm.lab_id);
            let data = await this.$root.reg(this.regForm);
            if(data.code == 1){
                this.showCopyRight = true;
                this.type = 1;
            }
            this.loading = false;
        },  
        checkType(){
            if(this.$route.query.type){
                this.type = this.$route.query.type;
            }           
        },
        async getLabname(){ 
            let data = await this.$root.getlabName();            
            if(data && data.code == 1 && data.data){
                this.labOptions = data.data;
                // 确保默认选中 0（其它）
                if(!this.regForm.lab_id){
                    this.regForm.lab_id = 0;
                }
            }else{
                // 如果请求失败，设置默认值
                this.labOptions = {0: '其它'};
                this.regForm.lab_id = 0;
            }
        },
        getLastGetCaptchaTime(){
            let time = window.localStorage.getItem("lastGetCaptchaTime");
            if(time){
                let now = Date.parse(new Date()) / 1000;
                if(now - time < 60){
                    this.lastGetCaptchaTime = time;
                    this.getCaptcha(true);
                }
            }
            else{
                this.lastGetCaptchaTime = 0;
            }
        },
        async getCaptcha(isSended=false,event="resetpwd"){
            //检查getCaptchaClass是否包含disabled
            if(this.getCaptchaClass.indexOf("disabled") != -1){
                return;
            }
            //转义事件
            let form = ""
            if(event == "resetpwd"){
                form = this.forgetForm;
            }
            if(event == "register"){
                form = this.regForm;
            }
            //禁用getCaptcha按钮
            this.getCaptchaClass = this.getCaptchaClass + " disabled";
            if(!isSended){
                this.getCaptchaLoading = true;
                try{
                    let data = null;
                    // 注册和找回密码使用手机验证码新接口 /api/sms/send
                    if(event === 'register' || event === 'resetpwd'){
                        // 校验手机号存在
                        if(!form || !form.mobile){
                            this.$notify({
                                type: 'warning',
                                title: '通知',
                                message: '请输入手机号'
                            });
                            this.getCaptchaLoading = false;
                            this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","").replace("disabled","");
                            return;
                        }
                        const payload = {
                            event: event,
                            mobile: form.mobile
                        };
                        const res = await axios.post(window.config.api + 'index.php/api/sms/send', payload, {
                            headers: {
                                token: this.$root.token
                            }
                        });
                        data = res.data;
                    } else {
                        // 其它事件仍使用全局封装
                        data = await this.$root.sendCaptcha(event,form);
                    }

                    this.getCaptchaLoading = false;
                    if(data && data.code == 1){
                        //获取当前时间戳
                        let getTime = Date.parse(new Date()) / 1000;
                        this.lastGetCaptchaTime = getTime;
                        window.localStorage.setItem("lastGetCaptchaTime",getTime);
                        this.$notify({
                            type: 'success',
                            title: '通知',
                            message: data.msg
                        });
                    } else {
                        this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","").replace("disabled","");
                        if(data && data.msg){
                            this.$notify({
                                type: 'error',
                                title: '错误',
                                message: data.msg
                            });
                        }
                        return;
                    }
                } catch (err){
                    this.getCaptchaLoading = false;
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","").replace("disabled","");
                    this.$notify({
                        type: 'error',
                        title: '错误',
                        message: '发送验证码失败'
                    });
                    return;
                }
            }
            this.getCaptchaText = "已发送("+(59-(Date.parse(new Date()) / 1000 - this.lastGetCaptchaTime))+")";
            let listen = setInterval(() => {
                let nowTime = Date.parse(new Date()) / 1000;
                if(nowTime - this.lastGetCaptchaTime >= 60){
                    this.getCaptchaText = "获取验证码";
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","");
                    this.getCaptchaClass = this.getCaptchaClass.replace("disabled","");
                    clearInterval(listen);
                }
                else{
                    this.getCaptchaText = "已发送("+(59-(Date.parse(new Date()) / 1000 - this.lastGetCaptchaTime))+")";
                }                
            }, 1000);
        },
        async submitResetpwd(){
            this.getCaptchaLoading = true;
            let data = await this.$root.resetpwd(this.forgetForm);
            if(data){
                if(data.code == 1){
                    this.$notify({
                        type: 'success',
                        title: '通知',
                        message: data.msg
                    });
                    this.showForget = false;
                }
                else{
                    this.$notify({
                        type: 'error',
                        title: '错误',
                        message: data.msg
                    });
                }
            }
            this.getCaptchaLoading = false;
        },
    },
    created(){
        //this.getjobOptions();
        this.checkType();
        this.getLabname();
        this.test();
    },
    mounted(){        
        this.getLastGetCaptchaTime();
    }
}
</script>

<style lang="scss" scoped src="@/assets/css/loginPage.scss"></style>